import { render, staticRenderFns } from "./idera.vue?vue&type=template&id=0b0904a7"
import script from "./idera.vue?vue&type=script&lang=js"
export * from "./idera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports